module.exports = __webpack_public_path__ + "img/answerdash_steps_2.fa0b50e3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_logos/answerdash_steps_2.gif
// module id = GB6d
// module chunks = 0